import { Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'nc-txt-viewer',
  templateUrl: './txt-viewer.component.html',
  styleUrls: ['./txt-viewer.component.less']
})
export class TxtViewerComponent implements OnChanges {
  @Input() ncUrl: string = '';
  @Input() set ncSheetName(value: boolean | string) {
    this.sheetNameMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  sheetNameMode: boolean = false;

  constructor(private eleRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ncUrl']) {
      this.renderTextDocument();
    }
  }

  async renderTextDocument() {
    try {
      const response = await fetch(this.ncUrl);
      const text = await response.text();
      const container = this.eleRef.nativeElement.querySelector('#txt-container');
      container.innerHTML = `<pre>${this.escapeHtml(text)}</pre>`;
    } catch (error) {
      console.error('加载文本文件时出错:', error);
    }
  }

  private escapeHtml(unsafe: string): string {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
}
